import React from 'react';
import {motion} from "motion/react";

const AnimationBlock = ({children}) => {
    return (
    <motion.div
    initial ={{ opacity: 0, x: -20}}
    whileInView={{opacity: 1, x:0}}
    viewport={{ once: false, amount: 0.3 }}
    transition={{duration:0.5, ease: 'easeInOut'}}
    >
        {children}
        </motion.div>
        );
    };

export default AnimationBlock;